import React from "react";
import { Link } from "react-router-dom";
import {
  BodyAsFormData,
  encodedUrlBuliding,
} from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class RecentTransactions extends React.Component {
  static contextType = FilterContext;

  state = {
    recentTransactions: [],
    filters: "",
    showLoader: false,
    showGraph: false,
  };

  componentDidMount() {
    this.setState({ showLoader: true, showGraph: false });
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_recently_added_transactions",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({ showLoader: false, showGraph: true });
        this.setState({ recentTransactions: res.data });
      });
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });
      this.setState({ showLoader: true, showGraph: false });
      apiMiddleware
        .post(
          "api/edge/office/get_recently_added_transactions",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({ showLoader: false, showGraph: true });
          this.setState({ recentTransactions: res.data });
        });
    }
  }

  render() {
    return (
      <div className="widget widgetRightSideBar text-start widgetBlueBg">
        {this.state.showLoader && (
          <div className="row">
            <div className="col-lg-12 text-center">
              <img src="/edge/images/edgeLoader.gif" />
            </div>
          </div>
        )}
        {this.state.showGraph && (
          <div className="row">
            <div className="col-lg-12 text-start colorLightBlue widgetTableHeader">
              <p>Recently Added Transactions</p>
            </div>
            <div className="col-lg-12 mt-4 colorBlack searchTip">
              {this.state.recentTransactions.map((search, i) => (
                <div className="transactionInnerDiv" key={i}>
                  <Link
                    target="_blank"
                    to={encodedUrlBuliding("leaseId", search.lease_id)}
                  >
                    <p className="dateTag">{search.date}</p>
                    <div className="recentSearch recentTransaction">
                      <div className="recentBorderBottom">
                        <h2>
                          {search.tenant} - {search.complex}
                        </h2>
                        <span>
                          {search.micromarket}, {search.city}
                        </span>
                        <div className="areaDiv">
                          <p className="area">
                            Area:{" "}
                            {search.area == null || search.area == 0
                              ? search.carpet_area
                              : search.area}{" "}
                            sft{" "}
                            <span
                              className="area"
                              title={
                                search.area == null || search.area == 0
                                  ? "Carpet Area"
                                  : "Chargeable Area"
                              }
                            >
                              (
                              {search.area == null || search.area == 0
                                ? "Car..."
                                : "Char..."}
                              )
                            </span>
                          </p>
                          <p className="area">
                            Rent: {search.rent} ₹ / sqft / month
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps)(RecentTransactions);
